import React, { useState, useEffect } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../components/MaterialDataGrid'
import MaterialTypography from '../../components/MaterialTypography'
import { AppBar, Card, CardHeader, Stack, Tab, Tabs } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import BASEURL from '../Utils/Baseurl';
import axios from 'axios';
import { useUserDetails } from '../../context/auth'
import MaterialBox from '../../components/MaterialBox'
import Swal from 'sweetalert2'
const EmployeeSalary = () => {

    const navigate = useNavigate();
    const tabName = JSON.parse(sessionStorage.getItem("employeeSalaryTab"));
    const {AccessData,setEmpdisplay,setshowemp} = useUserDetails();
    const [tabValue, setTabValue] = useState("TYPE_ONE");
    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: 'init'
    })
    const [employeeSalaryList, setEmployeeSalaryList] = useState([])

    useEffect(() => {
        if (!tabValue) {
            if (tabName) {
            setTabValue(tabName);
            } else {
            setTabValue("TYPE_ONE");
            }
            return;
        }

        onSalaryStructureSubmit();
    }, [tabValue]);

    const SalaryStructureListTable = {
        columns: [
            {
                field: "empid",
                headerName: "Employee ID",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "name",
                headerName: "Employee Name",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "ctc",
                headerName: "Annual CTC",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "netPay",
                headerName: "Net Salary (M)",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            ...(tabValue === "TYPE_ONE"
            ? [
                {
                    field: "totalBenefits",
                    headerName: "Total Benefits",
                    width: 200,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "totalDeductions",
                    headerName: "Total Deductions",
                    width: 200,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                },
                {
                    field: "gross",
                    headerName: "Gross Salary (M)",
                    width: 200,
                    editable: false,
                    disableColumnMenu: true,
                    sortable: true,
                }
                ]
            : []),
            {
                field: "salaryStructure",
                headerName: "Salary Structure",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            
        ],
        rows: employeeSalaryList?.map(sal => {
            return {
                
                id: sal.id,
                empid:sal.user.empid,
                name: sal.user.firstName + " " + sal.user.lastName,
                ctc: sal.ctc,
                netPay : sal.netPay,
                gross: sal.gross,
                totalBenefits: sal.totalBenefits,
                totalDeductions: sal.totalDeductions,
                salaryStructure: sal.salaryStructure?.structureName,
                // monthlyGrossAmount : sal.monthlyGrossAmount,
                // netAmount: sal.netAmount,
                // monthlyNetAmount : sal.monthlyNetAmount,
                // structureName : sal.structureName
            }
        })
    }

    const handleSetTabValue = (event, newValue) => {
        sessionStorage.setItem("employeeSalaryTab", JSON.stringify(newValue));

        setTabValue(newValue);
    };

    const handleNewSalaryStructure = () => {
        setEmpdisplay(false)
        setshowemp(false)
        navigate('/employee-salary/add-employee-salary', { state: { tabName: tabValue } })
    }

    const onEmployeeListClick = (e) => {
        if (e?.id) {
            setEmpdisplay(true)
            setshowemp(true)
            navigate(`/employee-salary/add-employee-salary?id=${e?.id}`, { state: { tabName: tabValue } })

        }
    }


    const onSalaryStructureSubmit = async () => {
        const query =
            tabValue === "TYPE_ONE"
            ? `
                query AllEmployeesalary {
                allEmployeeCalcualtedsalary {
                    id
                    ctc
                    gross
                    totalDeductions
                    totalBenefits
                    netPay
                    overallSum
                    difference
                    basicPercentage
                    salaryStructure {
                    id
                    structureName
                    }
                    user {
                    id
                    firstName
                    lastName
                    empid
                    }
                    breakdown {
                    type
                    componentName
                    percentage
                    monthly
                    yearly
                    }
                }
                }
            `
            : `
                query allTypeTwoEmployeeSalaries {
                allTypeTwoEmployeeSalaries {
                    id
                    yearlyCtc
                    monthlyCtc
                    totalComponentYearly
                    totalComponentMonthly
                    yearlyNetPay
                    monthlyNetPay
                    componentBreakdown
                    createdAt
                    updatedAt

                    employee {
                    id
                    empid
                    username
                    firstName
                    lastName
                    }

                    salaryStructure {
                    id
                    structureName
                    }
                }
                }
            `;

        try {
            setPageState((prev) => ({
            ...prev,
            loading: true,
            }));

            const response = await axios.post(
            BASEURL,
            { query },
            {
                headers: {
                "Content-Type": "application/json",
                },
            }
            );

            const employeeSalaryResponse =
  tabValue === "TYPE_ONE"
    ? response?.data?.data?.allEmployeeCalcualtedsalary || []
    : (response?.data?.data?.allTypeTwoEmployeeSalaries || []).map(
        (item) => ({
          ...item,

          // Make employee look like user
          user: item.employee,

          // Match TYPE_ONE field names
          ctc: item.yearlyCtc,
          netPay: item.monthlyNetPay,
          gross: item.totalComponentMonthly,

          totalBenefits: 0,
          totalDeductions: 0,
        })
      );

            setEmployeeSalaryList(employeeSalaryResponse);

            setPageState((prev) => ({
            ...prev,
            loading: false,
            state: "success",
            }));
        } catch (error) {
            console.error("ResponseError:", error);

            Swal.fire({
            position: "center",
            icon: "error",
            title:
                error?.response?.data?.errors?.[0]?.message ||
                error?.message ||
                "Failed to fetch employee salaries",
            showConfirmButton: false,
            timer: 2500,
            });

            setPageState((prev) => ({
            ...prev,
            loading: false,
            }));
        }
    };

    return (
        <DashboardLayout>
            <Card >
                <CardHeader title={(
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Employee Salary list
                            </MaterialTypography>
                            {/* <MaterialTypography variant="caption" color="text">
                                List of Employee Salary that you can get details of Employee Salary.
                            </MaterialTypography> */}
                        </Stack>
                        {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddEmployeeSalary" && item.can_access
                ) && (
                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleNewSalaryStructure()}
                        >
                            Configure Salary
                        </MaterialButton>
                )}
                    </Stack>


                )} />
               <MaterialBox
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "80%",
                }}
                >
                    <MaterialBox
                        sx={{
                        width: {
                            xs: "100%",
                            sm: "90%",
                            md: "80%",
                        },
                        }}
                    >
                        <AppBar position="static">
                            <Tabs
                                orientation={"horizontal"}
                                value={tabValue}
                                onChange={handleSetTabValue}
                                variant="fullWidth"
                                sx={{
                                    backgroundColor: "transparent",
                                }}
                            >
                                <Tab label="Type 1" value="TYPE_ONE" />
                                <Tab label="Type 2" value="TYPE_TWO" />
                            </Tabs>
                        </AppBar>
                    </MaterialBox>
                </MaterialBox>
                <MaterialDataGrid
                    customHeight={550}
                    rows={SalaryStructureListTable.rows}
                    columns={SalaryStructureListTable.columns}
                    checkboxSelection={false}
                    isSelectable={false}
                    onRowClick={onEmployeeListClick}
                    loading={pageState.loading}
                    localeText={{
                        noRowsLabel: (
                            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                    No employee salary found
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    You have not yet add any employee salary details. Click on the "Configure Salary" button to start adding employee salary details.
                                </MaterialTypography>
                            </Stack>
                        )
                    }}
                />
            </Card>
        </DashboardLayout>
    )
}

export default EmployeeSalary
